<template>
  <div class="search-result-list d-flex flex-column">
    <div class="text-caption font-weight-bold grey--text mb-2 flex-grow-0 d-flex justify-space-between align-center">
      KẾT QUẢ TÌM KIẾM
      <v-btn
        v-if="!loading && total > 0"
        color="primary"
        text
        small
        class="text-none px-1"
        @click="$emit('click:export')"
        title="Kết xuất dữ liệu"
      >
        <v-icon left small class="mr-1">mdi-export</v-icon>
        {{ total }} kết quả
      </v-btn>
    </div>

    <div v-if="loading" class="flex-grow-1 d-flex justify-center align-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else-if="items.length === 0"
      class="flex-grow-1 d-flex justify-center align-center text-caption grey--text font-italic">
      Không tìm thấy kết quả nào
    </div>

    <div v-else class="mt-2">
      <v-list dense class="py-0">
        <v-list-item v-for="(item, i) in items" :key="i" class="px-0 elevation-1 mt-2 bg-white">
          <v-list-item-content class="pa-3">
            <v-layout align-center class="full-width">
              <div class="pr-3 full-width">
                <div :title="item.name" class="d-flex align-center">
                  <div class="text-truncate font-weight-bold text-subtitle-1">
                    {{ item.name || `Đối tượng ID: ${item.id}` }}
                  </div>
                  <v-spacer />
                  <v-btn small title="Bay tới" icon v-if="item.geometry" @click.stop="onClickItem(item)">
                    <v-icon small>mdi-crosshairs-gps</v-icon>
                  </v-btn>
                  <v-btn small icon :loading="detailLoadingId === item.id" :disabled="detailLoadingId === item.id"
                    @click="showInfo(item)">
                    <v-icon small>mdi-information-outline</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-layout>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>

    <div class="flex-grow-0 pt-2" v-if="total > limit">
      <v-pagination :value="page" @input="onPageChange" :length="Math.ceil(total / limit)" :total-visible="5"
        small></v-pagination>
    </div>


  </div>
</template>

<script>
import { fitBounds } from '@utils/helper-map'

export default {
  name: 'SearchResultList',
  props: {
    items: { type: Array, default: () => [] },
    total: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
    page: { type: Number, default: 1 },
    limit: { type: Number, default: 20 },
    detailLoadingId: { type: [Number, String], default: null }
  },
  inject: ['getMap'],
  methods: {
    onPageChange(p) {
      this.$emit('update:page', p)
      this.$emit('page-change', p)
    },
    showInfo(item) {
      this.$emit('click:info', item)
    },
    onClickItem(item) {
      if (item && item.geometry) {
        this.getMap(map => {
          fitBounds(map, item.geometry)
        })
        this.$root.$emit('layer-control:hightlight-layer', {
          type: 'FeatureCollection',
          features: [{ type: 'Feature', geometry: item.geometry, properties: {} }],
        })
      }
    },
  }
}
</script>

<style scoped>
.bg-white {
  background-color: #fff;
}
</style>
